<form nz-form nzLayout="vertical">
  <nz-form-item >
    <nz-form-label [nzRequired]="attribute.mandatory" nz-tooltip [nzTooltipTitle]="label">
      {{ label }}
    </nz-form-label>

    <nz-form-control [nzErrorTip]="'Campo obrigatório'">

      <!-- SELECT (único) -->
      <nz-select *ngIf="kind === 'select'"
        class="full" nzShowSearch nzAllowClear
        [(ngModel)]="attribute.datavalue"
        nzPlaceHolder="Selecione...">
        <nz-option *ngFor="let o of options"
                  [nzValue]="o.nzValue" [nzLabel]="o.nzLabel"></nz-option>
      </nz-select>

      <!-- MULTISELECT -->
      <nz-select *ngIf="kind === 'multiselect'"
        class="full" nzMode="multiple" nzShowSearch nzAllowClear
        [nzMaxMultipleCount]="maxMultiple"
        [(ngModel)]="attribute.datavalue"
        nzPlaceHolder="Selecione...">
        <nz-option *ngFor="let o of options"
                  [nzValue]="o.nzValue" [nzLabel]="o.nzLabel"></nz-option>
      </nz-select>

      <!-- TEXTO -->
      <input *ngIf="kind === 'text'" nz-input class="full"
            [(ngModel)]="attribute.datavalue" [required]="attribute.mandatory" />

      <!-- NÚMERO + UNIDADE -->
      <nz-input-group *ngIf="kind === 'number-unit'"
        class="full" [nzAddOnAfter]="hasUnits ? unitTpl : null">
        <input nz-input type="number" [(ngModel)]="attribute.datavalue"
              [required]="attribute.mandatory" />
      </nz-input-group>
      <ng-template #unitTpl>
        <nz-select [(ngModel)]="attribute.unitvalue" style="width: 90px;">
          <nz-option *ngFor="let u of attribute.attribute_info.attribute_unit_list"
                    [nzValue]="u" [nzLabel]="u"></nz-option>
        </nz-select>
      </ng-template>

      <!-- DATA -->
      <nz-date-picker *ngIf="kind === 'date'" class="full"
                      [(ngModel)]="attribute.datavalue"></nz-date-picker>

      <!-- TAGS (criação livre de itens) -->
      <ng-container *ngIf="kind === 'tags'">
        <div class="multi-field">
          <nz-select class="full"
            nzMode="tags" nzAllowClear
            [nzMaxMultipleCount]="maxMultiple"
            [(ngModel)]="attribute.datavalue"
            nzPlaceHolder="Digite o valor e pressione Enter de Tags...">
          </nz-select>

          <nz-select *ngIf="hasUnits" class="unit"
            [(ngModel)]="attribute.unitvalue" nzPlaceHolder="Un.">
            <nz-option *ngFor="let u of attribute.attribute_info.attribute_unit_list"
                      [nzValue]="u" [nzLabel]="u"></nz-option>
          </nz-select>
        </div>
      </ng-container>

    </nz-form-control>
  </nz-form-item>
</form>
<!-- RECURSÃO -->
<div class="attr-children" *ngIf="activeChildren.length">
  <div class="attr-children__title">Atributos dependentes</div>
  <shopee-attribute-field
    *ngFor="let child of activeChildren; trackBy: trackByAttr"
    [attribute]="child">
  </shopee-attribute-field>
</div>